"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var Label = function (props) {
    var theme = core_1.useTheme();
    var tooltip = null;
    if (props.tooltip) {
        tooltip = (react_1.default.createElement(Tooltip_1.default, { title: props.tooltip, "aria-label": props.tooltip, placement: "right", arrow: true, enterTouchDelay: 0, leaveTouchDelay: 3000 },
            react_1.default.createElement(InfoOutlined_1.default, { color: "primary", fontSize: "small" })));
    }
    return (react_1.default.createElement("div", { style: {
            marginBottom: theme.spacing(1),
            textAlign: "left",
            marginTop: theme.spacing(0.3),
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
        } },
        react_1.default.createElement("div", { style: __assign({ marginRight: theme.spacing(1) }, props.style) }, props.label),
        tooltip));
};
exports.default = Label;
